export const safeLs =
  typeof localStorage !== 'undefined' ? localStorage : undefined;
